import { Alert, Button } from "@mui/material";
import { PagePaper } from "@/components/Paper";

/** 法人マスタ画面の描画エラー時に表示する代替UI（ErrorBoundary の fallback） */
export const CorporateMasterErrorFallback: React.FC<{
  resetError: () => void;
}> = ({ resetError }) => (
  <PagePaper>
    <Alert
      severity="error"
      action={
        <Button
          color="inherit"
          onClick={() => {
            resetError();
            window.location.reload();
          }}
        >
          再読み込み
        </Button>
      }
    >
      画面の表示中にエラーが発生しました。再読み込みしてください。
    </Alert>
  </PagePaper>
);
